'use strict';
require('../../modules/es6.promise');
require('../../modules/es7.promise.finally');
module.exports = require('../../modules/_core').Promise['finally'];



//////////////////
// WEBPACK FOOTER
// /buddy/wp/web/app/themes/qol/node_modules/core-js/fn/promise/finally.js
// module id = 307
// module chunks = 0